// extracted by mini-css-extract-plugin
export default {"inputFileContainer":"InputFile_inputFileContainer__Z+FzF","hiddenInput":"InputFile_hiddenInput__Ud2Iq","fileName":"InputFile_fileName__Jvias","label":"InputFile_label__MkPNs"};